"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxSagaThunk = require("redux-saga-thunk");

var _utils = require("../../utils");

var _ResourceDetailLoader = _interopRequireDefault(require("./components/ResourceDetailLoader"));

var _ResourceListLoader = _interopRequireDefault(require("./components/ResourceListLoader"));

var _default = function _default(_ref) {
  var entities = _ref.entities,
      resource = _ref.resource,
      store = _ref.store;

  if (!(0, _utils.isPlainObject)(store)) {
    throw new Error('`createResourceHelpers` requires a redux store object be passed as `store` property!');
  }

  var _resource$actions = resource.actions,
      resourceCreateRequest = _resource$actions.resourceCreateRequest,
      resourceDeleteRequest = _resource$actions.resourceDeleteRequest,
      resourceDetailReadRequest = _resource$actions.resourceDetailReadRequest,
      resourceListCreateRequest = _resource$actions.resourceListCreateRequest,
      resourceListReadRequest = _resource$actions.resourceListReadRequest,
      resourceUpdateRequest = _resource$actions.resourceUpdateRequest;

  var createHelper = function (requestAction, thunkNameFn, resourceSelector, entitiesSelector) {
    return function (resourcePath, entityType) {
      var thunkName = thunkNameFn(resourcePath); // TODO decide how to handle extra needle/data for resourceUpdateRequest

      var action = requestAction(resourcePath, entityType);

      var resourceSelect = function (state) {
        return resourceSelector(state, resourcePath);
      };

      return {
        action,
        selectors: {
          done: function done(state) {
            return (0, _reduxSagaThunk.done)(state, thunkName);
          },
          fulfilled: function fulfilled(state) {
            return (0, _reduxSagaThunk.fulfilled)(state, thunkName);
          },
          // eslint-disable-next-line jest/no-disabled-tests
          pending: function pending(state) {
            return (0, _reduxSagaThunk.pending)(state, thunkName);
          },
          rejected: function rejected(state) {
            return (0, _reduxSagaThunk.rejected)(state, thunkName);
          },
          resource: resourceSelect,
          result: function resultsSelect(state) {
            var detail = resourceSelect(state); // TODO in future be able to check if actually normalized

            return entityType ? entitiesSelector(state, entityType, detail) : detail;
          }
        }
      };
    };
  };

  var resourceCreate = createHelper(function (resourcePath, entityType) {
    return function (params) {
      return resourceCreateRequest(resourcePath, params, entityType);
    };
  }, function (resourcePath) {
    return `${resourcePath}Create`;
  }, resource.selectors.getDetail, entities.selectors.getDetail);
  var resourceDelete = createHelper(function (resourcePath, entityType) {
    return function (needle) {
      return resourceDeleteRequest(resourcePath, needle, entityType);
    };
  }, function (resourcePath) {
    return `${resourcePath}Delete`;
  }, resource.selectors.getList, entities.selectors.getList);
  var resourceDetailRead = createHelper(function (resourcePath, entityType) {
    return function (needle, params) {
      return resourceDetailReadRequest(resourcePath, needle, params, entityType);
    };
  }, function (resourcePath) {
    return `${resourcePath}DetailRead`;
  }, resource.selectors.getDetail, entities.selectors.getDetail);
  var resourceListCreate = createHelper(function (resourcePath, entityType) {
    return function (data) {
      return resourceListCreateRequest(resourcePath, data, entityType);
    };
  }, function (resourcePath) {
    return `${resourcePath}ListCreate`;
  }, resource.selectors.getList, entities.selectors.getList);
  var resourceListRead = createHelper(function (resourcePath, entityType) {
    return function (params) {
      return resourceListReadRequest(resourcePath, params, entityType);
    };
  }, function (resourcePath) {
    return `${resourcePath}ListRead`;
  }, resource.selectors.getList, entities.selectors.getList);
  var resourceUpdate = createHelper(function (resourcePath, entityType) {
    return function (needle, data) {
      return resourceUpdateRequest(resourcePath, needle, data, entityType);
    };
  }, function (resourcePath) {
    return `${resourcePath}Update`;
  }, resource.selectors.getDetail, entities.selectors.getDetail);
  return {
    ResourceDetailLoader: function ResourceDetailLoaderWithStore(props) {
      return _react.default.createElement(_reactRedux.Provider, {
        store: store
      }, _react.default.createElement(_ResourceDetailLoader.default, props));
    },
    ResourceListLoader: function ResourceListLoaderWithStore(props) {
      return _react.default.createElement(_reactRedux.Provider, {
        store: store
      }, _react.default.createElement(_ResourceListLoader.default, props));
    },
    resourceCreate,
    resourceDelete,
    resourceDetailRead,
    resourceListCreate,
    resourceListRead,
    resourceUpdate
  };
};

exports.default = _default;